import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { SessionStorageService } from 'angular-web-storage';

import * as enums from '../../models/enumerations';
import * as models from '../../models';
import * as services from '../../services';

@Component({
    selector: "tag-cell",
    template: `
        <div class="cont">
          <mat-chip-set class="tag-chip-list" style="vertical-align: middle">
            @for (tag of tags; track tag) {
              <mat-chip style="vertical-align: middle">{{tag}}</mat-chip>
            }
          </mat-chip-set>
        </div>
        `,
    styles: [
        `
        .cont {
            margin-top:1px
        }

        ::ng-deep .tag-chip-list .mdc-evolution-chip-set__chips {
            flex-wrap: unset !important;
            //width: 250px;
            overflow-x: scroll;
        }
  
        `
    ],
    standalone: false
})
export class TagComponent implements ICellRendererAngularComp {
    private params: any;

    tags: Array<string> = [];

    constructor(){}

    async agInit(params: any): Promise<void> {
        if(params.value == null){
            return;
        }
        this.params = params;

        //let roles: Array<models.Role> = this.storage.get('roles');
        let tags: Array<string> = this.params.value;
        this.tags = tags;

        // if(tags != null){
        //     this.tags = tags.split('|');
        // }
    }

    refresh(params: any): boolean {
        return false;
    }
}